export default __webpack_public_path__ + "static/media/landing-logo.501a7ab5.png";